import { Button, Card, Col, Row, Table } from "antd";
import { useNavigate } from "react-router-dom";
import { ColumnsType } from "antd/lib/table";

import styles from "../index.module.less";
import { General } from "../../../util/General";
import userImage from "../../../assets/pictures/user_img.png";
import { RouteConstants } from "../../../constants/ApplicationConstants/RouteConstants";
import { Modules } from "../../../constants/DatabaseConstants/MasterConstant";
import Loading from "../../common/Loading";

import type { VisitorLogData } from "../../../shared/interface/dashboard.interface";
import { ParkingHistoryReportData } from "../../../shared/interface/Report/allUsersReport.interface";

interface TodaysVisitorsCardProps {
  data: ParkingHistoryReportData[];
  loading: boolean;
  isFullScreen?: boolean;
}

const TodaysVisitorsCard = (props: TodaysVisitorsCardProps) => {
  const navigate = useNavigate();

  const handleAddVisitor = () => {
    navigate(`${RouteConstants.MASTER_MANAGEMENT_PAGE}/${Modules.KEY_FOB_ALLOCATION_MASTER}?isVisitor=true`);
  };

  const columns: ColumnsType<ParkingHistoryReportData> = [
    {
      align: "center",
      title: "KeyFob",
      key: "key_fob_token",
      dataIndex: "key_fob_token",
      render: (text) => <div>{text ?? "-"}</div>,
      onCell: () => ({
        className: styles["table-cell-small"]
      }),
      width: "17%"
    },
    {
      align: "center",
      title: "In Time",
      key: "in_time",
      dataIndex: "in_time",
      render: (text) => <div>{General.formatTime(text) ?? "-"}</div>,
      onCell: () => ({
        className: styles["table-cell-small"]
      }),
      width: "15%"
    },
    {
      align: "center",
      title: "Out Time",
      key: "out_time",
      dataIndex: "out_time",
      render: (text) => <div>{General.formatTime(text) ?? "-"}</div>,
      onCell: () => ({
        className: styles["table-cell-small"]
      }),
      width: "15%"
    },
    // {
    //   align: "center",
    //   title: "Time Diff",
    //   key: "in_out_time_diff",
    //   dataIndex: "in_out_time_diff",
    //   render: (text) => <div>{text ?? "-"}</div>,
    //   onCell: () => ({
    //     className: styles["table-cell-small"]
    //   })
    // },
    {
      align: "center",
      title: "User",
      key: "full_name",
      dataIndex: "full_name",
      render: (text) => <div>{text ?? "-"}</div>,
      onCell: () => ({
        className: styles["table-cell-small"]
      })
    },
    {
      align: "center",
      title: "Contact No.",
      key: "mobile_number",
      dataIndex: "mobile_number",
      render: (text) => <div>{text ?? "-"}</div>,
      onCell: () => ({
        className: styles["table-cell-small"]
      })
    }
  ];

  const renderUI = () => (
    <>
      <div className={styles["parking-card-header"]}>
        <div>{""}</div>
        <span className={props?.isFullScreen ? styles["card-title-full-screen"] : styles["card-title"]}>{"Today's Visitors"}</span>
        <Button size="small" className="gx-mb-0 gx-mr-5 button-gradiant" onClick={handleAddVisitor}>
          Add Visitor
        </Button>
      </div>

      {props.loading ? (
        <Loading />
      ) : !props.loading && props?.data && props?.data?.length > 0 ? (
        <Row gutter={[16, 16]} className={props?.isFullScreen ? styles["full-screen-layout"] : ""}>
          <Col span={props?.isFullScreen ? 6 : 4} className={styles["visitor-icon-section"]}>
            <img src={userImage} className={styles["user-image"]} />
            <div className={styles["card-count"]}>{General.numberWithCommas(props?.data?.length ?? 0)}</div>
          </Col>
          <Col span={props?.isFullScreen ? 18 : 20} className={styles["visitor-table-section"]}>
            <Table
              scroll={{ y: props?.isFullScreen ? "75vh" : "23vh" }}
              className="gx-table-responsive"
              columns={columns}
              dataSource={props?.data}
              bordered
              rowKey="sr_no"
              pagination={false}
              size="small"
              components={{
                header: {
                  cell: (props: React.HTMLProps<HTMLTableCellElement>) => <th {...props} className={`${props.className} ${styles["custom-table-header"]}`} />
                }
              }}
            />
          </Col>
        </Row>
      ) : (
        <div className={styles["parking-card-section"]}>
          <svg width="100%">
            <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" className="h3">
              No Data!
            </text>
          </svg>
        </div>
      )}
    </>
  );

  return props?.isFullScreen ? (
    <div className="gx-text-center gx-p-2">{renderUI()}</div>
  ) : (
    <Card title={null} bodyStyle={{ padding: "15px" }} className={`gx-card gx-text-center ${styles["card-container"]}`}>
      {renderUI()}
    </Card>
  );
};

export default TodaysVisitorsCard;
